import React, { FC, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import TwTooltip from '../../../TwTooltip/TwTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NumberUtils from '../../../../utils/numberUtils';
import { TwButton, TwButtonType } from '../../../TwButtons/TwButtons';
import { IOrderMargin } from '../../../../redux/api/orders/orders.model';

interface OrderMarginProps {
  orderMargin: IOrderMargin;
  toolTipMsg: string;
  isBokeredLoadsOn: boolean;
}

const OrderMargin: FC<OrderMarginProps> = ({ orderMargin, toolTipMsg, isBokeredLoadsOn }) => {
  const [show, setShow] = useState(false);

  const calculateOrderMargin = useMemo(() => {
    return (
      orderMargin.revenue -
      orderMargin.driver_pay -
      orderMargin.payable_amount -
      orderMargin.total_expenses
    );
  }, [orderMargin]);

  return (
    <>
      <Box component="div" className="load-detail__data-container__overview--sub-title">
        Order Margin
      </Box>
      <Box
        component="div"
        className="load-detail__data-container__overview__client-load"
        sx={{
          paddingBottom: '0 !important'
        }}
      >
        {NumberUtils.getCurrency(calculateOrderMargin, 4)}
        <TwTooltip title={toolTipMsg} placement="top">
          <InfoOutlinedIcon sx={{ height: '16px' }} />
        </TwTooltip>
      </Box>
      <TwButton
        label={!show ? 'Show breakdown' : 'Hide breakdown'}
        action={(): void => setShow(!show)}
        type={TwButtonType.text}
        sx={{
          width: '150px',
          padding: '0px',
          paddingBottom: '20px',
          justifyContent: 'flex-start',
          textTransform: 'none !important'
        }}
      />
      {show && (
        <>
          <Box component="div" className="load-detail__data-container__overview--sub-title">
            Revenue
          </Box>
          <Box component="div" className="load-detail__data-container__overview__client-load">
            {NumberUtils.getCurrency(orderMargin.revenue, 4)}
          </Box>
          <Box component="div" className="load-detail__data-container__overview--sub-title">
            Driver Trip Pay
          </Box>
          <Box component="div" className="load-detail__data-container__overview__client-load">
            {NumberUtils.getCurrency(orderMargin.driver_pay, 4)}
          </Box>
          {isBokeredLoadsOn && (
            <>
              <Box component="div" className="load-detail__data-container__overview--sub-title">
                Payable amount on brokered loads
              </Box>
              <Box component="div" className="load-detail__data-container__overview__client-load">
                {NumberUtils.getCurrency(orderMargin.payable_amount, 4)}
              </Box>
            </>
          )}
          <Box component="div" className="load-detail__data-container__overview--sub-title">
            Sum of other expenses
          </Box>
          <Box component="div" className="load-detail__data-container__overview__client-load">
            {NumberUtils.getCurrency(orderMargin.total_expenses, 4)}
          </Box>
        </>
      )}
    </>
  );
};

export default OrderMargin;
